module.exports = __webpack_public_path__ + "static/media/pattern@2x.83278b0c.png";